// Cluster N (v0.6.0) — single source of truth for uploader-progress query keys.
// Mirror of Cluster M progressKeys.ts with /uploader/me + /admin/uploaders paths.

export const UPLOADER_PROFILE_SUMMARY_KEY = ['uploader', 'me', 'profile-summary'] as const;

export const UPLOADER_HISTORY_KEY = (months: number) =>
  ['uploader', 'me', 'history', months] as const;

export const ADMIN_UPLOADER_PROFILE_KEY = (uploaderId: number) =>
  ['admin', 'uploaders', uploaderId, 'profile-summary'] as const;

export const ADMIN_UPLOADERS_PROGRESS_OVERVIEW_KEY =
  ['admin', 'uploaders-progress-overview'] as const;
